import api from './api';

const actionItemService = {
  async getPriorities() {
    const res = await api.get('/Priority');
    return Array.isArray(res.data) ? res.data : [];
  },

  async getIssueCategories() {
    const res = await api.get('/IssueCategory');
    return Array.isArray(res.data) ? res.data : [];
  },

  async getOverdueNotifications() {
    const res = await api.get('/action-items/overdue-notifications');
    return Array.isArray(res.data) ? res.data : [];
  },
};

export default actionItemService;
